import { useEffect, useMemo } from "react";
import { Navigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { RedirectLogin } from "@/components/layout/RedirectLogin";
import { LAST_COURSE_DASHBOARD_KEY } from "@/hooks/useRememberCourseDashboard";
import {
  LOGOUT_RETURN_KEY,
  finishLogin,
  isAppPath,
  loginStartedFrom,
} from "@/lib/courseLogin";

const storedPath = (key: string) => {
  const saved = sessionStorage.getItem(key);
  return saved && isAppPath(saved) ? saved : null;
};

export const RootRedirect = () => {
  const { accounts } = useMsal();
  const isSignedIn = accounts.length > 0;
  const rememberedDashboard = isSignedIn
    ? storedPath(LAST_COURSE_DASHBOARD_KEY)
    : null;
  const courseLeftAtLogout = isSignedIn ? null : storedPath(LOGOUT_RETURN_KEY);
  const cameBackWithoutSigningIn = useMemo(
    () => !!courseLeftAtLogout && loginStartedFrom(courseLeftAtLogout),
    [courseLeftAtLogout]
  );

  const forgetFinishedSignIn = () => {
    if (!isSignedIn && !cameBackWithoutSigningIn) return;
    finishLogin();
  };
  useEffect(forgetFinishedSignIn, [isSignedIn, cameBackWithoutSigningIn]);

  if (isSignedIn) {
    return <Navigate to={rememberedDashboard ?? "/impressum"} replace />;
  }
  if (!courseLeftAtLogout || cameBackWithoutSigningIn) {
    return <Navigate to="/impressum" replace />;
  }
  return <RedirectLogin returnTo={courseLeftAtLogout} />;
};
